<template>
  <div class="day-container">
    <HeaderTwo
      :planType="planType"
      @planTypeChange="planTypeChange"
    ></HeaderTwo>
    <!-- <Header title="管道气" :planType="planType"></Header> -->
    <!-- <Header title="LNG" :planType="planType"></Header> -->
    <div v-if="planType == 'png'" class="tabs-container">
      <van-tabs v-model="curTab">
        <van-tab
          v-for="tab in tabList"
          :key="tab.key"
          :title="tab.name"
          :name="tab.key"
        ></van-tab>
        <Scroll>
          <PngDayPlanTabContent
            v-if="curTab == 'add'"
            :curTab="curTab"
          ></PngDayPlanTabContent>
          <PngDayPlanTabContentDetail
            v-if="curTab == 'detail' || curTab == 'modifyDetail'"
            :curTab="curTab"
          ></PngDayPlanTabContentDetail>
          <PngDayPlanTabContentModify
            v-if="curTab == 'modify'"
            :curTab="curTab"
          ></PngDayPlanTabContentModify>
        </Scroll>
      </van-tabs>
    </div>
    <div v-if="planType == 'lng'" class="tabs-container">
      <van-tabs v-model="curTab">
        <van-tab
          v-for="tab in tabList"
          :key="tab.key"
          :title="tab.name"
          :name="tab.key"
        ></van-tab>
        <Scroll>
          <LngDayPlanTabContent :curTab="curTab"></LngDayPlanTabContent>
        </Scroll>
      </van-tabs>
    </div>
  </div>
</template>
<script>
// import Header from "./components/Header";
import HeaderTwo from "./components/HeaderTwo";
import PngDayPlanTabContent from "./png/PngDayPlanTabContent";
import PngDayPlanTabContentDetail from "./png/PngDayPlanTabContentDetail";
import PngDayPlanTabContentModify from "./png/PngDayPlanTabContentModify";
import LngDayPlanTabContent from "./lng/LngDayPlanTabContent";
import Scroll from "@/components/Scroll";
export default {
  name: "LngDayPlan",
  components: {
    // Header,
    HeaderTwo,
    PngDayPlanTabContent,
    PngDayPlanTabContentDetail,
    PngDayPlanTabContentModify,
    LngDayPlanTabContent,
    Scroll
  },
  data() {
    return {
      planType: this.$route.query.planType || "png",
      tabList: [
        {
          key: "add",
          name: "日指定",
        },
        {
          key: "detail",
          name: "日指定查看",
        },
        {
          key: "modify",
          name: "变更申请",
        },
        {
          key: "modifyDetail",
          name: "变更查看",
        },
      ],
      curTab: "add",
      timer: "",
    };
  },
  methods: {
    planTypeChange(type) {
      this.planType = type;
      this.$nextTick(() => {
        console.log(this.planType);
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl';

.tabs-container >>> .van-tabs {
  // height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

.tabs-container >>> .van-tabs .van-tabs__wrap {
  height: 89px;
}

.tabs-container >>> .van-tabs .van-tabs__wrap .van-tabs__nav {
  background: #F4F4F4;
}

.tabs-container >>> .van-tabs .van-tabs__wrap .van-tabs__nav .van-tab {
  font-size: 32px;
  line-height: 45px;
  color: #333333;
}

.tabs-container >>> .van-tabs .van-tabs__wrap .van-tabs__nav .van-tab--active {
  color: #E12020;
}

.tabs-container >>> .van-tabs .van-tabs__wrap .van-tabs__nav .van-tabs__line {
  bottom: 16px;
}

.tabs-container >>> .van-tabs .van-tabs__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.day-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tabs-container {
  flex: 1;
  display: flex;
  overflow: hidden;
}
</style>